/*
 * Styled dropdown for select.custom-select (collection sort).
 * Vanilla replacement for the previous jQuery implementation; re-initializes
 * after facet filtering re-renders the sort control via AJAX.
 */
(function () {
  function buildCustomSelect(select) {
    if (select.dataset.customSelectInit) return;
    select.dataset.customSelectInit = 'true';

    var wrapper = document.createElement('div');
    wrapper.className = 'custom-select-wrapper';
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);

    var shell = document.createElement('div');
    shell.className = select.className.replace(/\bselect__select\b/, '').trim();
    var selectedOption = select.selectedOptions && select.selectedOptions[0];
    var initialLabel = (selectedOption && selectedOption.text.trim()) || select.getAttribute('placeholder') || '';
    var html = '<span class="custom-select-trigger">' + initialLabel + '</span>';
    html += '<div class="custom-options">';
    select.querySelectorAll('option').forEach(function (opt) {
      html += '<span class="custom-option ' + (opt.className || '') + '" data-value="' + opt.value + '">' + opt.innerHTML + '</span>';
    });
    html += '</div>';
    shell.innerHTML = html;
    select.style.display = 'none';
    wrapper.appendChild(shell);

    var trigger = shell.querySelector('.custom-select-trigger');
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      document.addEventListener('click', function () { shell.classList.remove('opened'); }, { once: true });
      shell.classList.toggle('opened');
    });

    var firstOption = shell.querySelector('.custom-option:first-of-type');
    if (firstOption) {
      firstOption.addEventListener('mouseenter', function () { firstOption.parentElement.classList.add('option-hover'); });
      firstOption.addEventListener('mouseleave', function () { firstOption.parentElement.classList.remove('option-hover'); });
    }

    if (selectedOption) {
      var initialMatch = shell.querySelector('.custom-option[data-value="' + CSS.escape(selectedOption.value) + '"]');
      if (initialMatch) initialMatch.classList.add('selection');
    }

    shell.querySelectorAll('.custom-option').forEach(function (optionEl) {
      optionEl.addEventListener('click', function () {
        select.value = optionEl.dataset.value;
        shell.querySelectorAll('.custom-option').forEach(function (o) { o.classList.remove('selection'); });
        optionEl.classList.add('selection');
        shell.classList.remove('opened');
        trigger.textContent = optionEl.textContent;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    var current = new URLSearchParams(location.search).get('sort_by');
    if (current) {
      var match = shell.querySelector('.custom-option[data-value="' + CSS.escape(current) + '"]');
      if (match) {
        match.classList.add('selection');
        trigger.textContent = match.textContent;
      }
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('select.custom-select').forEach(buildCustomSelect);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    var facets = document.getElementById('main-collection-filters');
    if (facets && 'MutationObserver' in window) {
      new MutationObserver(function () { initAll(facets); }).observe(facets, { childList: true, subtree: true });
    }
  });
})();
